import { Fragment, useState, useEffect, useContext } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import * as moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

import "./Attendance.css";
import Context from "context/context";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import attendanceAPI from "../../../apis/panel/Attendance/attendance.js";

const localizer = momentLocalizer(moment);

const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 250,
        minHeight: 10, 
        fontSize:12,
        lineHeight: "1.5", 
        padding: "10px 10px",    
        cursor: "pointer",
        backgroundColor: "#163559ff",
        color: "#ffffff",
    },
});

export default function Attendance() {
  const { state, dispatch } = useContext(Context);

  const [employeeSchedule, setEmployeeSchedule] = useState([]);
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState("month");
  const [currentMonth, setCurrentMonth] = useState(moment().startOf("month"));
  const [visibleRange, setVisibleRange] = useState({ start: null, end: null });

  const [employeedepartment, setemployeedepartment] = useState("");
  
    useEffect(() => {
      let employeeDatas = state.employee;
      if (employeeDatas) {
        setemployeedepartment(employeeDatas?.departmentName);
       
      }
    }, [state.employee]);
  


  const { getEmployeeScheduleAPI } = attendanceAPI();

  const [employeeCode, setemployeeCode] = useState();
  useEffect(() => {
    let employeeDatas = state.employee;
    if (employeeDatas) {
      setemployeeCode(employeeDatas?.employeeCode);
    }
  }, [state.employee]);

  const renderDayPropGetter = (date) => {
    const day = moment(date).day();
    const isWeekend = day === 0 || day === 6;
    const isInCurrentVisibleMonth =
      moment(date).month() === moment(currentMonth).month() &&
      moment(date).year() === moment(currentMonth).year();

    const isPublicHoliday = publicHolidays.some((holiday) =>
      holiday.isSame(date, "day")
    );

    if (isPublicHoliday) {
      return {
        style: {
          backgroundColor: "#00FF0033",
          borderRadius: "20px",
          textAlign: "center",
          alignItems: "center",
        },
      };
    }
    if (!isInCurrentVisibleMonth && isWeekend) {
      return {
        style: {
          backgroundColor: "#f0f0f0",
        },
      };
    }

    if (!isInCurrentVisibleMonth) {
      return {
        style: {
          backgroundColor: "#fafafa",
          color: "#ccc",
        },
      };
    }

    if (isWeekend) {
      return {
        style: {
          backgroundColor: "#f0f0f0",
        },
      };
    }
    return {};
  };

  useEffect(() => {
    if (employeeCode) {
      const today = moment();
      const calendarStart = moment(today).startOf("month").startOf("week");
      const calendarEnd = moment(today).endOf("month").endOf("week");

      setVisibleRange({
        start: calendarStart.toDate(),
        end: calendarEnd.toDate(),
      });

      handleGetEmployeeScheduleAPI(calendarStart.toDate(), calendarEnd.toDate());
    }
  }, [employeeCode]);

  const publicHolidays = [
    moment("2024-01-01"),
    moment("2024-07-04"),
    moment("2024-12-25"),
  ];

  const handleGetEmployeeScheduleAPI = async (startDate, endDate) => {
  dispatch({ type: "SET_LOADING", payload: true });

  try {
    const query = {
      employeeCode: employeeCode,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
    };

    const result = await getEmployeeScheduleAPI(query);
   
    const attendanceData = result?.data?.data || [];
    const leaveData = result?.data?.leaveData || [];
    const holidayData = result?.data?.holidayData || [];

    const shiftCountByDate = attendanceData.reduce((acc, d) => {
  const key = d.date; 
  acc[key] = (acc[key] || 0) + 1;
  return acc;
}, {});

    const attendanceEvents = attendanceData.map((d) => {
  const startDate = new Date(d.first_check_in);
   const isOvernight = d.shift_name === 'Overnight';
  
  const shiftDateKey = d.date;

  const multipleShiftsSameDate = shiftCountByDate[shiftDateKey] > 1;

  const adjustedEndDate = (startDate.toDateString() !== endDate.toDateString())
    ? new Date(moment(startDate).endOf('day').subtract(1, 'minute'))
    : endDate;

  return {
    ...d,
    start: isOvernight && multipleShiftsSameDate
      ? new Date(startDate.getTime() + 6 * 60 * 60 * 1000)
      : startDate,
    end:adjustedEndDate ,
    shiftName: d.shift_name,
    totalDuration: d.total_duration,
    actual: d.actual_date,
    startActual:startDate,
    endActual:new Date(d.last_check_out) ,
    tooltipCheckIn:d.actual_check_in,
     tooltipCheckOut:d.actual_check_out
   
  };
});


    const leaveEvents = leaveData.map((leave) => ({
      ...leave,
      title: "",
      displayTitle: leave.title || "-",
    }));

    const holidayEvents = holidayData.map((holiday) => ({
      ...holiday,
      title: "",
      displayTitle: holiday.title || "-",
    }));

    
    let combinedEvents = [...attendanceEvents, ...leaveEvents, ...holidayEvents];

    combinedEvents = combinedEvents.map((event, index) => ({
      ...event,
      sortOrderIndex: index, 
    }));

    

    setEmployeeSchedule(combinedEvents);
  } catch (error) {
    console.error("Error fetching attendance:", error);
    setEmployeeSchedule([]);
  } finally {
    dispatch({ type: "SET_LOADING", payload: false });
  }
};

  const CustomToolbar = ({ label, onNavigate, onView }) => {
    return (
      <div className="cal-view-nav">
        <div className="cal-view-nav-left">
          <ArrowBackIosIcon
            className="cal-view-nav-back-arrow"
            onClick={() => onNavigate("PREV")}
          />
          <ArrowForwardIosIcon
            className="cal-view-nav-forward-arrow"
            onClick={() => onNavigate("NEXT")}
          />
          <button
            className="cal-view-nav-today-attendance-btn"
            onClick={() => onNavigate("TODAY")}
          >
            Click to View Today
          </button>
        </div>
        <div className="cal-view-nav-center">
          <span>{label}</span>
        </div>
      </div>
    );
  };

 
  const CustomEvent = ({ event }) => {
    
   const checkIn = moment(event?.startActual).format(" hh:mm A");
    const checkOut = moment(event?.endActual).format(" hh:mm A");
    const duration = event?.totalDuration || "-";

    const tooltipCheckIn = moment(event?.tooltipCheckIn).format("MMMM D, YYYY hh:mm A");
    const tooltipCheckOut = moment(event?.tooltipCheckOut).format("MMMM D, YYYY hh:mm A");
  
    const tooltipContent = (
    <div>
      
      <div><strong>Check-In:</strong> {tooltipCheckIn}</div>
      <div><strong>Check-Out:</strong> {tooltipCheckOut}</div>
     
    </div>
  );


    if (event?.type && (event?.type === "LEAVE" || event?.type === "HOLIDAY")) {
      return (
         
        <div style={{ fontSize: "13px", textAlign: "center",order: event.sortOrderIndex }}>
          <div >
            <strong>{event?.displayTitle}</strong>
          </div>
        </div>
        
      );
    } else {
      return (
         <CustomWidthTooltip title={tooltipContent} placement="top" arrow>
        <div
          style={{
            fontSize: "13px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%", 
            textAlign: "center",
            order: event.sortOrderIndex
          }}
        >
         <div>
  {employeedepartment === "KPO/BPO" ? (
    <div>
      <div><strong>Shift:</strong> {event?.shiftName}</div>
      <div>{checkIn} - {checkOut}</div>
      <div><strong>Duration:</strong> {duration}</div>
    </div>
  ):(
     <div style={{ fontSize: "13px", lineHeight: "1.4" }}>
          <div>
            <strong>Check-in:</strong> {checkIn}
          </div>
          <div>
            <strong>Check-out:</strong> {checkOut}
          </div>
          <div>
            <strong>Duration:</strong> {duration}
          </div>
        </div>

  )}
</div>
        </div>
        </CustomWidthTooltip>
      );
    }
  };
 
  const getEventColor = (durationInHours, type) => {
    let baseStyle = {
      color: "#fff",
      textAlign: "center",
      borderRadius: "6px",
      padding: "6px 4px",
      marginBottom: "4px",
    };

    if (type === "LEAVE") {
      return { ...baseStyle, backgroundColor: "#000099" };
    }

    if (type === "HOLIDAY") {
      return { ...baseStyle, backgroundColor: "#CC6600" };
    }

    const durationMatch = durationInHours?.match(/(\d+)\s*hrs?[\s,]*(\d*)\s*mins?/i);
    let ActualDurationInHours = 0;

    if (durationMatch) {
      const hours = parseInt(durationMatch[1], 10) || 0;
      const minutes = parseInt(durationMatch[2], 10) || 0;
      ActualDurationInHours = hours + minutes / 60;
    }

    if (ActualDurationInHours < 8) {
      return { ...baseStyle, backgroundColor: "#CD5C5C" }; // red
    }

    return { ...baseStyle, backgroundColor: "#008a27" }; // green
  };

  const eventPropGetter = (event) => {
    const style = getEventColor(event?.total_duration, event?.type);
    return { style };
  };

  const getindicatorColor = (title) => {
    switch (title) {
      case "Office In Time > 8 hrs":
        return "#008a27";
      case "Office In Time < 8 hrs":
        return "#CD5C5C";
      case "Approved Leave":
        return "#000099";
      case "Public Holiday":
        return "#CC6600";
      default:
        return "#1f7a8c";
    }
  };


  

  return (
    <Fragment>
      <div className="custom-calendar">
        <Card
          style={{
            width: "100%",
            padding: "20px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            borderRadius: "10px",
            height: "fit-content",
          }}
        >
          <div className="custom-calendar-header-attendance">Attendance - My View</div>
          <div
            style={{
              padding: "15px 0px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            {[
              "Office In Time > 8 hrs",
              "Office In Time < 8 hrs",
              "Approved Leave",
              "Public Holiday",
            ]?.map((i) => (
              <span className="indicator-div" key={i}>
                <span
                  style={{ backgroundColor: getindicatorColor(i) }}
                  className="indicator-color"
                ></span>
                <span className="indicator-name">{i}</span>
              </span>
            ))}
          </div>
          <Calendar
            popup
            date={date}
            view={view}
            onNavigate={(newDate) => {
              setDate(newDate);
              setCurrentMonth(moment(newDate).startOf("month"));
            }}
            onView={(newView) => setView(newView)}
            views={["month"]}
            onRangeChange={(range) => {
              let startDate, endDate;

              if (Array.isArray(range)) {
                startDate = range[0];
                endDate = range[range.length - 1];
              } else {
                startDate = range.start;
                endDate = range.end;
              }

              setVisibleRange({ start: startDate, end: endDate });
              handleGetEmployeeScheduleAPI(startDate, endDate);
            }}
            localizer={localizer}
    
  events={employeeSchedule}
            dayPropGetter={renderDayPropGetter}
            eventPropGetter={eventPropGetter}
            components={{
              toolbar: CustomToolbar,
              month: {
                event: CustomEvent,
              },
            }}
            startAccessor="start"
            endAccessor="end"
            titleAccessor="title"
          />
        </Card>
      </div>
    </Fragment>
  );
}
